import React from "react";
import { trans } from "./../../Lang";
import { NavLink } from "react-router-dom";

export default class LoginSmile extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      username: "",
      password: "",
      programId: "",

      errorPassword: null,
      showPassword: false,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(e) {
    e.preventDefault();
    const { username, password, programId } = this.state;

    this.props.onSubmit({
      username,
      password,
      programId,
    });
  }

  render() {
    const { username, showPassword, errorPassword } = this.state;
    const { optionPrograms } = this.props;

    return (
      <div className="mt-2">
        <form
          onSubmit={this.handleSubmit}
          id="form-login-smile"
          className="form-auth bg-white"
        >
          <div className="row">
            <div className="input-field col s12">
              <input
                required
                id="username"
                type="text"
                value={username}
                onChange={(e) => this.setState({ username: e.target.value })}
                className="validate"
                autoComplete="one-time-code"
              />
              <label htmlFor="username">Username SMILE</label>
              <span className="red-text text-darken-2">{errorPassword}</span>
            </div>

            <div className="input-field col s12">
              <input
                required
                id="password"
                type={!showPassword ? "password" : "text"}
                onChange={(e) => this.setState({ password: e.target.value })}
                className="validate"
              />
              <i
                className="btn-show-hide-password material-icons"
                onClick={(e) => this.setState({ showPassword: !showPassword })}
              >
                {showPassword ? "visibility_off" : "visibility"}
              </i>
              <label htmlFor="password">Password</label>
              {errorPassword ? (
                <span className="red-text text-darken-2">{errorPassword}</span>
              ) : null}
              <div className="forgot-password-wrapper">
                <NavLink className="forgot-password-text" to="/forgot-password">
                  Lupa Password?
                </NavLink>
              </div>
            </div>

            <div className="col s12">
              <label>Program</label>
              <select
                name="program_id"
                onChange={(e) => this.setState({ programId: e.target.value })}
                className="browser-default"
                required
              >
                <option value="">Select Option</option>
                {optionPrograms
                  ? optionPrograms.map((opt) => (
                      <option value={opt.value}>{opt.label}</option>
                    ))
                  : null}
              </select>
            </div>

            <div className="form-auth__button-group mt-s">
              <button className="btn full mb-s">{trans.login}</button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Auth/components/LoginSmile.js